/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AuthTransferInRequest = {
  /**
   * Start mode: the platform host that holds the session to move here (e.g. app.getgram.ai)
   */
  sourceHost?: string | undefined;
  /**
   * Callback mode: the opaque one-time transfer code from the source host's transferOut endpoint
   */
  code?: string | undefined;
  /**
   * Optional URL path to land on once the session is established on this host
   */
  redirect?: string | undefined;
  /**
   * Start mode: replace a session this browser already holds on this host for the same user. Without it, the callback keeps that session and its organization, so a stale source session cannot undo an organization switch made here. Set it right after switching organization on the source host.
   */
  replaceSession?: boolean | undefined;
};

export type AuthTransferInResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export type AuthTransferInRequest$Outbound = {
  source_host?: string | undefined;
  code?: string | undefined;
  redirect?: string | undefined;
  replace_session?: boolean | undefined;
};

/** @internal */
export const AuthTransferInRequest$outboundSchema: z.ZodMiniType<
  AuthTransferInRequest$Outbound,
  AuthTransferInRequest
> = z.pipe(
  z.object({
    sourceHost: z.optional(z.string()),
    code: z.optional(z.string()),
    redirect: z.optional(z.string()),
    replaceSession: z.optional(z.boolean()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceHost: "source_host",
      replaceSession: "replace_session",
    });
  }),
);

export function authTransferInRequestToJSON(
  authTransferInRequest: AuthTransferInRequest,
): string {
  return JSON.stringify(
    AuthTransferInRequest$outboundSchema.parse(authTransferInRequest),
  );
}

/** @internal */
export const AuthTransferInResponse$inboundSchema: z.ZodMiniType<
  AuthTransferInResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
    });
  }),
);

export function authTransferInResponseFromJSON(
  jsonString: string,
): SafeParseResult<AuthTransferInResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthTransferInResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthTransferInResponse' from JSON`,
  );
}
